// extracted by mini-css-extract-plugin
export default {"wrap":"XI-z","fullWidth":"YI-z","hideOnDesktop":"ZI-z","content":"_I-z","hasOpenedNav":"aJ-z","crumbsList":"bJ-z","dropdownsWrap":"cJ-z"};